/**
 * Opus Quick Actions - Context-aware action buttons
 */

import { Search, TrendingUp, Briefcase, GitBranch } from 'lucide-react';

interface QuickActionsProps {
  onAction: (prompt: string) => void;
  disabled?: boolean;
}

interface QuickAction {
  label: string;
  prompt: string;
  icon: React.ElementType;
}

const QUICK_ACTIONS: QuickAction[] = [
  {
    label: 'Find React developers',
    prompt: 'Find candidates with React skills who are available now',
    icon: Search,
  },
  {
    label: 'Show open jobs',
    prompt: 'Show me all open jobs and their pipeline status',
    icon: Briefcase,
  },
  {
    label: 'Dashboard stats',
    prompt: 'Give me an overview of this month\'s recruitment metrics',
    icon: TrendingUp,
  },
  {
    label: 'Pipeline overview',
    prompt: 'What candidates need attention in the pipeline?',
    icon: GitBranch,
  },
];

export function QuickActions({ onAction, disabled }: QuickActionsProps) {
  return (
    <div className="flex flex-wrap gap-2">
      {QUICK_ACTIONS.map((action) => {
        const Icon = action.icon;
        return (
          <button
            key={action.label}
            onClick={() => onAction(action.prompt)}
            disabled={disabled}
            className="
              inline-flex items-center gap-1.5 px-3 py-1.5
              text-xs text-text-secondary
              bg-bg-tertiary hover:bg-bg-elevated
              border border-white/10 rounded-full
              transition-colors
              disabled:opacity-50 disabled:cursor-not-allowed
            "
          >
            <Icon className="w-3 h-3" />
            {action.label}
          </button>
        );
      })}
    </div>
  );
}
